import Backup from "./Backup/Backup"
import Splatnet from "./Splatnet/Splatnet"
import classes from "./Usersettings.module.css"
import Language from "./Language/Language"
import OnlineSync from "./FlioSync/OnlineSync"
import { useTranslation } from "react-i18next"
import pb from "../../lib/pocketbase"
import { useState } from "react"

const Usersettings = props => {
    const { t } = useTranslation()
    const [rerender, setRerender] = useState(false)

    return (
        <>
            <h2>{t("other:Cmn_OptionTop.L_UserSetting-T_Text")}</h2>
            <div className={classes.Wrapper}>
                <Language />
                <Splatnet renderAgain={props.renderAgain} />
                <Backup key={rerender} />
                {pb.authStore.isValid ? <OnlineSync rerender={setRerender} /> : null}
            </div>
        </>
    )
}

export default Usersettings
